import Paste from "./Paste";

export default {
    button: Paste,
    name: "Paste",
};
